import { getGlobalVariables } from '@libs/core';

const ZENDESK_SNIPPET_URL = 'https://static.zdassets.com/ekr/snippet.js';

export const getZendeskScriptSrc = (zendeskKey?: string): string | undefined => {
    if (zendeskKey) {
        return `${ZENDESK_SNIPPET_URL}?key=${encodeURIComponent(zendeskKey)}`;
    }

    const { zendeskChatApiKey } = getGlobalVariables('zendeskChatApiKey');
    return zendeskChatApiKey;
};
